export default __webpack_public_path__ + "static/media/logo_green.b5336ef0.png";